import { useCheckboxState } from '../abstract/checkbox';

export function useOnShowFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { checked: onShow, setChecked: onOnShowChange } = useCheckboxState({
    defaultValue: query.onShow,
    filterKey: `onShow`,
    queryKey: `onshow`,
    setFilters,
    updateQuery,
  });

  return { onShow, onOnShowChange };
}
